let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("80oK6")).then(() => parcelRequire('2eUU2'));